import secondary from '../components/views/secondaryTrip/secondary.vue'
import createSecondaryTrip from '../components/views/secondaryTrip/createSecondaryTrip.vue'
import secondaryTripList from '../components/views/secondaryTrip/secondaryTripList.vue'

const routes = [
    {
        path: 'transfer-point-trip',
        component: secondaryTripList,
        name: 'secondaryTrip',
        meta: {
            description: '',
            title: 'Transfer Point Trips',
            requiresAuth: true
        }
    },
    {
        path: 'transfer-point-trip/transfer-point-trip-details/:_id',
        component: secondary,
        name: 'secondary',
        meta: {
            description: '',
            title: 'Transfer Point Trip Details',
            requiresAuth: true
        }
    },
    {
        path: 'transfer-point-trip/create-transfer-point-trip/:_id',
        component: createSecondaryTrip,
        name: 'createSecondaryTrip',
        meta: {
            // description: '', 
            title: 'Add / Update Transfer Point Trip',
            requiresAuth: true
        }
    },
]

export default routes



// WEBPACK FOOTER //
// ./src/routes/secondaryTrip.route.js